import CustomerCard from './CustomerCard';

export default CustomerCard;
